<template>
  <section>
    <navbar/>

    <section class="box-admin-point">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12">

            <!-- Value -->
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 content">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 content-pin">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <p class="certa">DIGITE SEU PIN</p>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12 group-input">
                  <input v-model="dataRegister.p" v-bind:type="inputType" :maxlength="pinLength" readonly/>
                  <ion-icon v-if="!setEye" @click="changeType" name="eye" class="eye"/>
                  <ion-icon v-if="setEye" @click="changeType" name="eye-off" class="eye"/>
                </div>

                <div class="group-numbers col-xs-12 col-sm-12 col-md-12 col-lg-12">

                  <div class="numbers-lines numbers-first">
                    <div v-on:click="pressDigit(1)" class="number">
                      1
                    </div>
                    <div v-on:click="pressDigit(2)" class="number">
                      2
                    </div>
                    <div v-on:click="pressDigit(3)" class="number">
                      3
                    </div>
                  </div>

                  <div class="numbers-lines numbers-second">
                    <div v-on:click="pressDigit(4)" class="col-md-12 number">
                      4
                    </div>
                    <div v-on:click="pressDigit(5)" class="col-md-12 number">
                      5
                    </div>
                    <div v-on:click="pressDigit(6)" class="col-md-12 number">
                      6
                    </div>
                  </div>

                  <div class="numbers-lines numbers-third">
                    <div v-on:click="pressDigit(7)" class="col-md-12 number">
                      7
                    </div>
                    <div v-on:click="pressDigit(8)" class="col-md-12 number">
                      8
                    </div>
                    <div v-on:click="pressDigit(9)" class="col-md-12 number">
                      9
                    </div>
                  </div>

                  <div class="numbers-lines numbers-fourth">
                    <div v-on:click="removeValue" class="col-md-12 number number-remove">
                      <ion-icon name="close-outline"></ion-icon>
                    </div>
                    <div v-on:click="pressDigit(0)" class="col-md-12 number">
                      0
                    </div>
                    <div v-on:click="checkPin" class="col-md-12 number number-check">
                      <ion-icon name="checkmark-outline"></ion-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 content content-second">
              <div class="col-xs-12 col-sm-4 col-md-5 col-lg-4 content-default content-qr">
                <div @click="openOrCloseQr(true)" class="default-body" :style="loadingRequest ? 'pointer-events: none;' : ''">
                  <div class="qr-code">
                    <img src="../../../../assets/img/point-register/qr-code.png" alt="qr-code">
                    <span>Visualizar QR Code</span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-8 col-md-7 col-lg-8 content-default content-time">
                <div class="default-body">
                  <div class="time-date">
                    <img src="../../../../assets/img/point-register/calendar.png" alt="calendario">
                    <span class="content-date">
                      <span class="date-label">Data</span>
                      <span class="date-day">{{ dateToday }}</span>
                    </span>
                  </div>
                  <div class="time-line"></div>
                  <div class="time-hours">
                    <img src="../../../../assets/img/point-register/clock.png" alt="relogio">
                    <span class="content-hours">
                      <span class="hours-label">Hora</span>
                      <span class="hours-day">{{ time }}</span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 content-default content-result">
                <div class="default-body">
                  <div v-if="loadingContent" class="loader-container">
                    <div class="spinner">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                      <div class="rect4"></div>
                      <div class="rect5"></div>
                    </div>
                  </div>

                  <div v-if="needPhotoToPointMode && userIsConfirmed" class="webcam-content">
                    <span class="user-label">Confirme o seu ponto:</span>
                    <div v-if="needPhotoToPointMode && haveCam" class="cam">
                      <video ref="video" id="video" width="640" height="480" autoplay="true"></video>
                      <canvas ref="canvas" id="canvas" width="640" height="480"></canvas>
                    </div>

                    <div class="user-btn">
                      <div class="btn-cancel" @click="removeValue()" :style="loadingRequest ? 'pointer-events: none;' : ''">Voltar</div>
                      <div class="btn-confirm" @click="checkLocalPoint()" :style="loadingRequest ? 'pointer-events: none;' : ''">
                        <span v-if="!loadingRequest">Confirmar Ponto</span>
                        <div class="loading-btn" v-else>
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="!loadingContent && dataUser.name && !userIsConfirmed" class="result-user">
                    <span class="user-label">Confirme o seu ponto:</span>
                    <img v-if="dataUser.imageUri" :src="dataUser.imageUri" alt="usuário">
                    <img v-if="!dataUser.imageUri" src="../../../../assets/img/user-default.png" alt="usuário">
                    <span class="user-confirm">
                      Você confirma ser
                      <b>{{ dataUser.name }}</b>
                      ?
                    </span>
                    <div class="user-btn">
                      <div class="btn-cancel" @click="removeValue()" :style="loadingRequest ? 'pointer-events: none;' : ''">Não</div>
                      <div class="btn-confirm" @click="confirmUser()" :style="loadingRequest ? 'pointer-events: none;' : ''">
                        <span v-if="!loadingRequest">Sim</span>
                        <div class="loading-btn" v-else>
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="!loadingContent && !dataUser.name && showQr" class="result-qr">
                    <span class="qr-label">Registro por QR Code</span>
                    <img src="../../../../assets/img/point-register/qrcode.png" alt="QR Code">
                    <span class="qr-use">
                      Use a opção de QR Code no seu MarQApp.
                    </span>
                    <span class="btn-return" @click="openOrCloseQr(false)">
                      <ion-icon name="arrow-back-outline"></ion-icon>
                      Voltar
                    </span>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="myModal" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">Aviso</h4>
            </div>

            <div class="modal-body">
              <div class="info">
                <p>É Necessario ativar a localização do navegador para registrar o ponto.</p>
              </div>
              <div class="info-block">
                <div>
                  <p>Caso você tenha <strong>bloqueado ou não permitido</strong> a busca pela localização do seu navegador, você precisa liberar essa ferramenta para poder registrar o seu ponto pelo navegador.</p>
                </div>
                <div class="">
                  <img src="../../../../assets/img/location-block.png" class="img-responsive"/>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Fechar</button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <vue-footer/>

  </section>
</template>

<script>
  import navbar from '../../components/navbar.vue'
  import swal from 'sweetalert';
  import moment from 'moment'

  import {USER_PIN, ADMIN_REGISTER_POINT, IS_DEBUG, GET_MAIN_HOME} from "../../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../../requestConfig";
  import { UTIL_SERVICE } from "../../../../utils";
  import vueFooter from "../../components/footer.vue";

  export default {
    name: "admin-register-point",
    components: {
      vueFooter,
      navbar,
    },
    data() {
      return {
        loadingContent: false,
        loadingRequest: false,
        inputType: "password",
        dataRegister: {
          p: "",
          latitude: 0,
          longitude: 0,
          deviceId: ""
        },
        dataUser: {},
        dataCode: '',
        pinLength: '',
        setEye: false,
        now: moment(),
        dateToday: new Date().toLocaleDateString(),
        showQr: false,
        lastPoints: {},
        currentPoints: '',
        needPhotoToRegisterInWeb: false,
        needPhotoToPointMode: false,
        haveCam: false,
        stream: null,
        captures: '',
        userIsConfirmed: false,
      }
    },
    methods: {
      stopVideoOnly(stream) {
        if(stream) {
          stream.getTracks().forEach((track) => {
            if (track.readyState == 'live' && track.kind === 'video') {
                track.stop();
            }
          });
        }
      },
      confirmUser() {
        if(this.needPhotoToPointMode) {
          this.getWebCamImg();
          this.userIsConfirmed = true;
          this.haveCam = true;
        } else {
          this.confirmPoint();
        }
      },
      checkPosition() {
        return new Promise(function (resolve, reject) {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        });
      },
      pressDigit(value) {
        if (this.dataRegister.p.length < this.pinLength) {
          this.dataRegister.p += value;
        } else {
          // swal("Aviso", "???", "warning");
        }
      },
      changeType() {
        this.setEye = !this.setEye

        if (this.inputType === "password") {
          this.inputType = "text"
        } else {
          this.inputType = "password"
        }
      },
      checkPin() {
        if (this.loadingContent === false) {
          this.loadingContent = true;
          REQUEST_SERVICE.get(USER_PIN + "?pin=" + this.dataRegister.p).then((response) => {
            UTIL_SERVICE.console("RESULT USER_PIN:", response.data);

            this.dataUser = response.data;
            this.loadingContent = false;
          }).catch(reason => {
            this.loadingContent = false;

            // Show errors.
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
        }
      },
      confirmPoint() {
        
        this.checkPosition().then((response) => {
          if (this.loadingRequest === false) {
            this.loadingRequest = true;
            

            let browserInfo = UTIL_SERVICE.checkBrowser();
            let now = new Date().getTime();

            let url = ADMIN_REGISTER_POINT;
            url += "?deviceModel=" + browserInfo.name;
            url += "&version=" + browserInfo.version;
            url += "&deviceType=3";
            url += "&companyId=" + JSON.parse(window.localStorage.getItem('userInfo')).company.id;
            url += "&deviceId=" + JSON.parse(window.localStorage.getItem('browserId'));
            url += "&p=" + this.dataRegister.p;
            url += "&longitude=" + response.coords.longitude;
            url += "&latitude=" + response.coords.latitude;
            url += "&dt=" + moment(new Date(), "YYYYMMDD HH:mm").format('YYYY-MM-DD HH:mm:ss');

            const maxAge = 5 * 60 * 1000;
            this.currentPoints = JSON.parse(localStorage.getItem("lastPoints"))

            let isRecent = '';

            if(this.currentPoints) {
              this.currentPoints = this.currentPoints.filter((content) => {
                let objHour = new Date(content.hour);
                let objTimestamp = objHour.getTime();
                return (now - objTimestamp) < maxAge;
              });

              isRecent = this.currentPoints.some((obj) => {
                if (obj.p === this.dataRegister.p) {
                  const objDate = new Date(obj.hour);
                  const diff = now - objDate.getTime();
                  return diff <= maxAge;
                }
                return false;
              });
            }

            isRecent = false;
            if(isRecent) {
              this.loadingRequest = false;
              swal("Aviso", 'Esse PIN marcou ponto há menos de 5 minutos. Favor tentar novamente daqui a pouco.', "warning");
              return
            }

            this.lastPoint = {
              p: this.dataRegister.p,
              hour: moment(new Date(), "YYYYMMDD HH:mm").format('YYYY-MM-DD HH:mm:ss'),
            }

            UTIL_SERVICE.console("URL:", url);

            const bodyRegisterPoint = {
              image: {
                imageBase64: ''
              }
            }

            try {
              
              if (this.needPhotoToPointMode && this.haveCam) {
                
                this.canvas = this.$refs.canvas;
                let context = this.canvas.getContext("2d").drawImage(video, 0, 0, 640, 480);
                this.captures = canvas.toDataURL("image/png");
                bodyRegisterPoint.image.imageBase64 = this.captures;
              }
            } catch (err) {
              this.$toast.error(err.message);
            }

            REQUEST_SERVICE.post(url, bodyRegisterPoint).then((response) => {
              UTIL_SERVICE.console("RESULT ADMIN_REGISTER_POINT:", response.data);

              if(this.currentPoints) {
                this.currentPoints.push(this.lastPoint)
                localStorage.setItem("lastPoints", JSON.stringify(this.currentPoints));
              } else {
                localStorage.setItem('lastPoints', JSON.stringify([this.lastPoint]))
              }

              this.loadingRequest = false;
              this.dataRegister.p = "";
              this.dataUser = "";

              this.userIsConfirmed = false;
              swal("Aviso", response.data, "success").then(() => this.stopVideoOnly(this.stream));
            }).catch(reason => {
              this.loadingRequest = false;
              this.stopVideoOnly(this.stream);

              // Show errors.
              reason.response.data.erros.map((value, index) => {
                swal("Aviso", value.value, "error");
              });
            });
          }
        }).catch(reason => {
          this.loadingRequest = false;

          $("#myModal").modal()
        });
      },
      confirmPointDev() {
        if (this.loadingRequest === false) {
          this.loadingRequest = true;

          let browserInfo = UTIL_SERVICE.checkBrowser();
          let now = new Date().getTime();

          let url = ADMIN_REGISTER_POINT;
          url += "?deviceModel=" + browserInfo.name;
          url += "&version=" + browserInfo.version;
          url += "&deviceType=3";
          url += "&companyId=" + JSON.parse(window.localStorage.getItem('userInfo')).company.id;
          url += "&userId=" + JSON.parse(window.localStorage.getItem('userInfo')).id;
          url += "&deviceId=" + JSON.parse(window.localStorage.getItem('browserId'));
          url += "&p=" + this.dataRegister.p;
          url += "&longitude=" + '-49.2578389';
          url += "&latitude=" + '-25.4284584';
          url += "&dt=" + moment(new Date(), "YYYYMMDD HH:mm").format('YYYY-MM-DD HH:mm:ss');

          const maxAge = 5 * 60 * 1000;
          this.currentPoints = JSON.parse(localStorage.getItem("lastPoints"))

          let isRecent = '';

          if(this.currentPoints) {
            this.currentPoints = this.currentPoints.filter((content) => {
              let objHour = new Date(content.hour);
              let objTimestamp = objHour.getTime();
              return (now - objTimestamp) < maxAge;
            });

            isRecent = this.currentPoints.some((obj) => {
              if (obj.p === this.dataRegister.p) {
                const objDate = new Date(obj.hour);
                const diff = now - objDate.getTime();
                return diff <= maxAge;
              }
              return false;
            });
          }
          isRecent = false;

          if(isRecent) {
            this.loadingRequest = false;
            swal("Aviso", 'Esse PIN marcou ponto há menos de 5 minutos. Favor tentar novamente daqui a pouco.', "warning");
            return
          }

          this.lastPoint = {
            p: this.dataRegister.p,
            hour: moment(new Date(), "YYYYMMDD HH:mm").format('YYYY-MM-DD HH:mm:ss'),
          }

          const bodyRegisterPoint = {
            image: {
              imageBase64: ''
            }
          }

          try {
            if (this.needPhotoToPointMode && this.haveCam) {
              this.canvas = this.$refs.canvas;
              let context = this.canvas.getContext("2d").drawImage(video, 0, 0, 640, 480);
              this.captures = canvas.toDataURL("image/png");
              bodyRegisterPoint.image.imageBase64 = this.captures;
            }
          } catch (err) {
            this.$toast.error(err.message);
          }

          UTIL_SERVICE.console("URL:", url);
          REQUEST_SERVICE.post(url, bodyRegisterPoint).then((response) => {
            UTIL_SERVICE.console("RESULT ADMIN_REGISTER_POINT:", response.data);

            if(this.currentPoints) {
              this.currentPoints.push(this.lastPoint)
              localStorage.setItem("lastPoints", JSON.stringify(this.currentPoints));
            } else {
              localStorage.setItem('lastPoints', JSON.stringify([this.lastPoint]))
            }

            this.loadingRequest = false;
            this.dataRegister.p = "";
            this.dataUser = "";


            this.userIsConfirmed = false;

            swal("Aviso", response.data, "success").then(() =>  this.stopVideoOnly(this.stream));
          }).catch(reason => {
            this.loadingRequest = false;
            this.stopVideoOnly(this.stream);

            // Show errors.
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
        }
      },
      checkLocalPoint() {
        if (IS_DEBUG) {
          this.confirmPointDev();
        } else {
          this.confirmPoint();
        }
      },
      getWebCamImg() {
        //https://jefrydco.id/en/blog/safe-access-vue-refs-undefined
        const interval = setInterval(() => {
          if(this.$refs.video) {
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia({ video: true })
            .then((stream) => {
              this.stream = stream;
              if(this.$refs) {
                this.$nextTick(
                  function() {
                    if(this.$refs.video) {
                      this.$refs.video.srcObject = stream;
                    }
                  }
                )
              }
            })
            .catch((error) => {
              this.haveCam = false;
              if(this.needPhotoToPointMode) {
                  this.$toast.error('Erro ao acessar a webcam.', {
                  position: 'top-center'
                });
              }
            });
          } else {
            this.$toast.error('Webcam not supported on this browser')
          }
            clearInterval(interval)
          }
        }, 50)
      },
      removeValue() {
        this.dataRegister.p = "";
        this.dataUser = "";
        this.userIsConfirmed = false;
        this.stopVideoOnly(this.stream)
      },
      getOnlyMain() {

        let url = GET_MAIN_HOME;
        if (JSON.parse(window.localStorage.getItem('userInfo'))) {
          url += "?i=" + JSON.parse(window.localStorage.getItem('userInfo')).id;
        }

        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT GET_MAIN_HOME:", response.data);

          this.dataCode = response.data

          if(response.data.pinCodeLength) {
            this.pinLength = response.data.pinCodeLength;
          } else {
            this.pinLength = 4;
          }
        }).catch(() => {
          this.pinLength = 6;
        })
      },
      openOrCloseQr(value) {
        if(value) {
          this.removeValue()
        }
        this.showQr = value
      }
    },
    beforeMount() {
      this.getOnlyMain();

      this.needPhotoToRegisterInWeb = UTIL_SERVICE.getStorage('userAccess').needPhotoToRegisterInWeb;
      this.needPhotoToPointMode = UTIL_SERVICE.getStorage('userAccess').needPhotoToPointMode;
    },
    mounted() {
      moment.locale('pt-br');
      window.localStorage.setItem('modePin', JSON.stringify({onlyPin: true}));
    },
    destroyed() {
      this.stopVideoOnly(this.stream)
    },
    computed: {
      time() {
        return this.now.format('HH:mm:ss');
      },
    },
    created() {
      setInterval(() => {
        this.now = moment();
      }, 1000);
    },
  }
</script>

<style lang="scss">
  .box-admin-point {
    margin-bottom: 10%;

    .content {
      margin-top: 66px;

      .content-pin {
        background: #FFFFFF;
        padding: 50px 60px;
        border-radius: 20px;

        p {
          font-weight: 400;
          font-size: 22px;
          color: #3A424E;
          text-align: center;
          margin-bottom: 40px;
        }

        .group-input {
          padding: 0;

          input {
            width: 100%;
            border-radius: 10px;
            border: none;
            background: #3A424E !important;
            height: 70px;
            margin-bottom: 30px;
            text-align: center;
            color: #fff !important;
            font-weight: bold;
            text-transform: uppercase;
            cursor: pointer;
            letter-spacing: 5px;
            font-size: 20px;
          }

          .eye {
            position: absolute;
            top: 23.1px;
            right: 0;
            margin-right: 35px;
            font-size: 25px;
            color: #fff;
            cursor: pointer;
          }
        }

        .group-numbers {
          padding: 0;

          .numbers-lines {
            display: flex;
            justify-content: space-between;
            margin-bottom: 13px;

            .number {
              padding: 30px 60px;
              background: #7F8897;
              width: 32%;
              border: 1px solid #7F8897;
              color: #FFFFFF;
              font-weight: 700;
              font-size: 32px;
              border-radius: 10px;
              cursor: pointer;
              height: 100px;
              display: flex;
              align-items: center;
              justify-content: center;
              transition: .2s;

              &:hover {
                background: #3A424E;
                border-color: #3A424E;
              }
            }

            .number-remove {
              border-color: #FF445D;
              background: #FF445D;
              padding: 30px 0;

              ion-icon {
                font-size: 75px;
              }

              &:hover {
                border-color: #E02A44;
                background: #E02A44;
              }
            }

            .number-check {
              border-color: #2ACC6B;
              background: #2ACC6B;
              padding: 30px 0;

              ion-icon {
                font-size: 64px;
              }

              &:hover {
                border-color: #1CB158;
                background: #1CB158;
              }
            }
          }

          .numbers-fourth {
            margin-bottom: 0;
          }
        }

        @media only screen and (max-width: 1199px) {
          padding: 50px 30px;
        }

        @media only screen and (max-width: 991px) {
          padding: 50px 60px;
        }
      }

      .content-default {
        .default-body {
          background: #FFFFFF;
          padding: 50px 60px;
          border-radius: 20px;
        }
      }

      .content-qr {
        padding-right: 5px;

        .default-body {
          padding: 40px 17px;
          transition: .2s;
          cursor: pointer;

          &:hover {
            background: #B4BECF;
          }

          .qr-code {
            display: flex;

            span {
              margin-left: 12px;
              font-weight: 400;
              line-height: 22px;
              font-size: 17px;
              width: min-content;
            }
          }
        }
      }

      .content-time {
        padding-left: 5px;

        .default-body {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 124px;
          padding: 40px 17px;

          .time-date {
            display: flex;

            img {
              margin-right: 7px;
            }

            .content-date {
              display: flex;
              flex-direction: column;
              align-items: flex-start;

              .date-label {
                font-weight: 400;
                font-size: 14px;
                color: #7E8DA7;
              }

              .date-day {
                font-weight: 700;
                font-size: 17px;
                color: #7E8DA7;
              }
            }
          }

          .time-hours {
            display: flex;

            img {
              margin-right: 7px;
            }

            .content-hours {
              display: flex;
              flex-direction: column;
              align-items: flex-start;

              .hours-label {
                font-weight: 400;
                font-size: 14px;
                color: #7E8DA7;
              }

              .hours-day {
                min-width: 75px;
                font-weight: 700;
                font-size: 17px;
                color: #7E8DA7;
              }
            }
          }

          .time-line {
            border-radius: 50%;
            width: 2px;
            height: 44px;
            background: #D1D1D1;
          }

          @media only screen and (max-width: 1199px) {
            padding: 17px 17px;

            .time-date {
              flex-direction: column;
              align-items: center;

              img {
                margin: 0;
              }

              .content-date {
                align-items: center;
              }
            }

            .time-hours {
              flex-direction: column;
              align-items: center;

              img {
                margin: 0;
              }

              .content-hours {
                align-items: center;
              }
            }

            .time-line {
              height: 44px;
            }
          }

          @media only screen and (max-width: 991px) {
            padding: 17px 17px;

            .time-date {
              flex-direction: row;
              align-items: center;

              img {
                margin: 7px;
              }

              .content-date {
                align-items: flex-start;
              }
            }

            .time-hours {
              flex-direction: row;
              align-items: center;

              img {
                margin: 7px;
              }

              .content-hours {
                align-items: flex-start;
              }
            }

            .time-line {
              height: 44px;
            }
          }
        }
      }

      .content-result {
        margin-top: 14px;

        .default-body {
          padding: 40px 30px;
          height: 572px;

          .webcam-content {
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            gap: 30px;
            height: 100%;

            .user-label {
              font-weight: 400;
              font-size: 22px;
              color: #3A424E;
              margin-bottom: 47px;
            }
            .cam {
              max-height: 200px;
              padding: 0 20px;
              margin-bottom: 30px;

              canvas {
                display: none;
              }

              video {
                width: 59%;
                max-height: 200px;
                overflow: hidden;
                border-radius: 35px;
                border: 4px solid var(--leftMenuColor);
                box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.25);
                transition: 0.5s;
              }

              p {
                color: var(--text);
                font-size: 13px;
                text-align: center;
              }


            }

            .user-btn {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              width: 100%;
              margin-top: 34px;

              .btn-cancel {
                background: #e6e6e6;
                border-radius: 10px;
                color: #3A424E;
                font-weight: 700;
                font-size: 16px;
                padding: 10px 85px;
                width: 40%;
                text-align: center;
                cursor: pointer;
                transition: .2s;
                display: flex;
                align-items: center;
                justify-content: center;

                &:hover {
                  background: rgba(70, 69, 69, 0.189)
                }
              }

              .btn-confirm {
                background: #4AD481;
                border-radius: 10px;
                color: #FFFFFF;
                font-weight: 700;
                font-size: 16px;
                width: 40%;
                cursor: pointer;
                transition: .2s;
                display: flex;
                align-items: center;
                justify-content: center;

                &:hover {
                  background: #1CB158;
                }

              }

              @media only screen and (max-width: 1199px) {
                .btn-cancel {
                  padding: 10px 60px;
                }

                .btn-confirm {
                  padding: 10px 60px;
                }
              }

              @media only screen and (max-width: 991px) {
                .btn-cancel {
                  padding: 10px 85px;
                }

                .btn-confirm {
                  padding: 10px 85px;
                }
              }
            }
          }
        }

        .result-user {
          display: flex;
          flex-direction: column;
          align-items: center;

          .user-label {
            font-weight: 400;
            font-size: 22px;
            color: #3A424E;
            margin-bottom: 47px;
          }

          .user-confirm {
            font-weight: 400;
            font-size: 22px;
            color: #3A424E;
            margin-top: 37px;

            b {
              font-weight: 400;
              color: #352DA5;
            }
          }

          .user-btn {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            margin-top: 34px;

            .btn-cancel {
              background: #FF6075;
              border-radius: 10px;
              color: #FFFFFF;
              font-weight: 700;
              font-size: 22px;
              padding: 10px 85px;
              cursor: pointer;
              transition: .2s;

              &:hover {
                background: #E02A44;
              }
            }

            .btn-confirm {
              background: #4AD481;
              border-radius: 10px;
              color: #FFFFFF;
              font-weight: 700;
              font-size: 22px;
              padding: 10px 85px;
              cursor: pointer;
              transition: .2s;

              &:hover {
                background: #1CB158;
              }

            }

            @media only screen and (max-width: 1199px) {
              .btn-cancel {
                padding: 10px 60px;
              }

              .btn-confirm {
                padding: 10px 60px;
              }
            }

            @media only screen and (max-width: 991px) {
              .btn-cancel {
                padding: 10px 85px;
              }

              .btn-confirm {
                padding: 10px 85px;
              }
            }
          }

          img {
            width: 260px;
            height: 260px;
            border-radius: 50%;
          }
        }

        .result-qr {
          display: flex;
          flex-direction: column;
          align-items: center;

          .qr-label {
            font-weight: 400;
            font-size: 22px;
            color: #191919;
            margin-bottom: 24px;
          }

          .qr-use {
            font-weight: 400;
            font-size: 14px;
            color: #191919;
            margin-top: 16px;
          }

          img {
            width: 265px;
            height: 265px;
          }

          .btn-return {
            margin-top: 76px;
            border: 1px solid #352DA5;
            border-radius: 8px;
            color: #352DA5;
            padding: 8px 16px;
            font-weight: 400;
            font-size: 22px;
            display: flex;
            flex-direction: row;
            align-items: center;
            cursor: pointer;
            transition: .2s;

            ion-icon {
              margin-right: 10px;
              font-size: 31px;
            }

            &:hover {
              color: #2F23D6;
              border-color: #2F23D6;
            }
          }
        }
      }
    }

    .content-second {
      padding: 0;
    }
  }

  /* Loading */
  .loader-container {
    z-index: 9999;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .spinner {
      width: max-content;

      .rect2 {
        -webkit-animation-delay: -1.1s;
        animation-delay: -1.1s;
      }

      .rect3 {
        -webkit-animation-delay: -1.0s;
        animation-delay: -1.0s;
      }

      .rect4 {
        -webkit-animation-delay: -0.9s;
        animation-delay: -0.9s;
      }

      .rect5 {
        -webkit-animation-delay: -0.8s;
        animation-delay: -0.8s;
      }
    }
  }

  .spinner > div {
    background-color: #1A0F6B;
    width: 8px;
    height: 64px;
    display: inline-block;
    -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
    animation: sk-stretchdelay 1.2s infinite ease-in-out;
  }

  @-webkit-keyframes sk-stretchdelay {
    0%, 40%, 100% { -webkit-transform: scaleY(0.4) }
    20% { -webkit-transform: scaleY(1.0) }
  }

  @keyframes sk-stretchdelay {
    0%, 40%, 100% {
      transform: scaleY(0.4);
      -webkit-transform: scaleY(0.4);
    }  20% {
         transform: scaleY(1.0);
         -webkit-transform: scaleY(1.0);
       }
  }
</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/adminRegisterPoint/adminRegisterPoint.vue